import * as qs from "query-string";
export default class QueryUtils {
  public static parse(query: string): { [key: string]: string } {
    if (!query) {
      return {};
    } else if (query.startsWith("?")) {
      return qs.parse(query.substr(1));
    } else {
      return qs.parse(query);
    }
  }

  public static stringify(
    params: { [key: string]: string | number },
    prependQuestionMark: boolean = true
  ): string {
    const query = qs.stringify(params);
    if (prependQuestionMark) {
      return `?${query}`;
    } else {
      return query;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/utils/QueryUtils.ts